<template>
  <div class="doc-nav-sidebar mb-4">
    <h4 class="mb-4 text-white text-center mt-3">Documentation</h4>
    <div v-for="page in pages" class="py-1 " style="font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif">
      <router-link class="documentation__link " :to="page.link">{{page.name}}</router-link>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'pc-documentation-nav',
    data () {
      return {
        pages: [
          {
            name: 'Quick Start',
            link: '/docs',
          },
          {
            name: 'Configuration File',
            link: '/docs/configuration-file',
          },
          {
            name: 'Tracing Variables',
            link: '/docs/variables-tracing',
          },
          {
            name: 'Django Support',
            link: '/docs/django-support',
          },
          {
            name: 'Debugging Tests',
            link: '/docs/debugging-support',
          },
          {
            name: 'FAQ',
            link: '/docs/faq',
          },
        ],
      }
    },
  }
</script>

<style scoped>
  .documentation__link {
    color: #fbfcfc !important;
  }
</style>